module.exports = __webpack_public_path__ + "static/chrome-ext-demo-8fc25797a2750e2b77c0ea3d9ddb5c8f.png";